import React from 'react';
import Grid from '@material-ui/core/Grid';
import {
    withTheme,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@material-ui/core';
import { useHistory } from 'react-router';
import { resetUrlFilters } from '../../pages/activitycards/components/urlFiltering';

const KeepCartModal = ({
    // onDecided has 1 parameter, true if should keep the cart, 0 if not
    onDecided,
    theme,
    showModal,
    MODAL_TYPE
}) => {
    const history = useHistory();
    return (
        <Dialog aria-labelledby="guest-new-modal" open maxWidth="sm">
            <DialogTitle>Keep cart</DialogTitle>
            <DialogContent>
                <Grid container spacing={1} justifyContent="center" alignItems="center">
                    <Grid item xs={12}>
                        <div>
                            You are about to change guests, should we keep the activities in the
                            cart?
                        </div>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    style={{ color: theme.palette.error.main }}
                    onClick={() => {
                        onDecided(true);
                        showModal(MODAL_TYPE.NONE);
                    }}
                >
                    Yes
                </Button>

                <Button
                    style={{ color: theme.palette.primary.main }}
                    onClick={() => {
                        onDecided(false);
                        showModal(MODAL_TYPE.NONE);
                        history.replace(resetUrlFilters());
                    }}
                >
                    No
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default withTheme(KeepCartModal);
